import { HealthcareOrganization } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ActionBar } from '@dreryk/react-components';

import { HealthcareOrganizationUpdateForm } from './HealthcareOrganizationUpdateForm';

type HealthcareOrganizationUpdatePanelProps = {
   readonly healthcareOrganization: HealthcareOrganization;
   readonly onUpdateCanceled: VoidFunction;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareOrganizationUpdatePanel = (props: HealthcareOrganizationUpdatePanelProps): JSX.Element => {
   return (
      <>
         <HealthcareOrganizationUpdateForm
            healthcareOrganization={props.healthcareOrganization}
            onDataChanged={props.onDataChanged}
         />
         <ActionBar.PrimaryLink
            testId='practiceDataUpdateCancel'
            label={commonTranslationKeys.cancel}
            onClick={props.onUpdateCanceled}
         />
      </>
   );
};
